import { render, staticRenderFns } from "./date-validated.vue?vue&type=template&id=5d483804&"
import script from "./date-validated.vue?vue&type=script&lang=js&"
export * from "./date-validated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports